import { COURSE_SEARCH_URL, GET_ALL_COURSE_LIST, GET_COURSES_DATA, GET_CATEGORY_COMPUNNEL } from '../config/api-url';
import { CoursesToken } from '../config/url';
import { getRequest, postRequest } from '../config/auth';

export const courseSearchAPI = (data) => getRequest(`${COURSE_SEARCH_URL}?${data}`, data);
export const getAllCourseListAPI = (data) => postRequest(`${GET_ALL_COURSE_LIST}`, data);
export const getEmployeeCourseListAPI = (data) => postRequest(`${GET_COURSES_DATA}`, data);
export const getCategoryCompunnelListAPI = (data) => postRequest(`${GET_CATEGORY_COMPUNNEL}`, data);
